import { Rss } from 'lucide-react'

type KineticFeedLinksProps = {
  className?: string
  variant?: 'default' | 'workshop'
}

/**
 * Compact feed links for Kinetic footers.
 * Provides persistent discoverability for RSS/Atom/JSON feeds (main insights + events/spotlights).
 */
export function KineticFeedLinks({ className = '', variant = 'default' }: KineticFeedLinksProps) {
  const isWorkshop = variant === 'workshop'
  const textClass = isWorkshop
    ? 'text-kinetic-outline/70'
    : 'text-kinetic-on-surface-variant/70'
  const labelClass = isWorkshop ? 'text-kinetic-outline/50' : 'text-kinetic-outline'
  const hoverClass = isWorkshop ? 'hover:text-white' : 'hover:text-kinetic-primary-container'

  return (
    <div
      className={`flex flex-wrap items-center gap-3 text-[10px] font-mono uppercase tracking-[0.2em] ${textClass} ${className}`}
    >
      <span className={labelClass}>Feeds</span>
      <a
        href="/feed.xml"
        className={`inline-flex items-center gap-1 transition-colors ${hoverClass}`}
        target="_blank"
        rel="noopener"
      >
        <Rss className="h-3 w-3" /> RSS
      </a>
      <a
        href="/atom.xml"
        className={`inline-flex items-center gap-1 transition-colors ${hoverClass}`}
        target="_blank"
        rel="noopener"
      >
        Atom
      </a>
      <a
        href="/feed.json"
        className={`inline-flex items-center gap-1 transition-colors ${hoverClass}`}
        target="_blank"
        rel="noopener"
      >
        JSON
      </a>
      <span className="text-kinetic-on-surface-variant/30">·</span>
      <a
        href="/spotlights.xml"
        className={`inline-flex items-center gap-1 transition-colors ${hoverClass}`}
        target="_blank"
        rel="noopener"
      >
        <Rss className="h-3 w-3" /> Events
      </a>
    </div>
  )
}
